// src/App.js
import React from 'react';
import Wrapper from './components/Wrapper';

function App() {
    return <Wrapper />;
}

export default App;
